import * as React from "react";
import type { SVGProps } from "react";
const SvgCurrencyCoinBath = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M11.701 6.192v1.4m0 8.407v1.4M21.6 12a9.6 9.6 0 1 1-19.2 0 9.6 9.6 0 1 1 19.2 0m-12-4.407h3.502a2.1 2.1 0 0 1 2.102 2.101v.1a2 2 0 0 1-2.002 2.002H9.6h3.502a2.1 2.1 0 0 1 2.102 2.101v.1A2 2 0 0 1 13.202 16H9.6z"
    />
  </svg>
);
export default SvgCurrencyCoinBath;
